"use client";

import { SLFooter } from "@/components/layout/SLFooter";
import SLLayoutGeneral from "@/components/layout/SLLayoutGeneral";
import { SLNavigation } from "@/components/layout/SLNavigation";
import { SLHomeContact } from "@/components/sections/home/SLHomeContact";
import { SLHomeHeader } from "@/components/sections/home/SLHomeHeader";
import { SLHomeEntryOverlay } from "@/components/templates/home/SLHomeEntryOverlay";
import { useScrollRestoration } from "@/hooks/useScrollRestoration";
import { Divider, Stack, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import { useRef } from "react";

export function SLHomePageTemplate({
  video,
  expertiseSection,
  aboutSection,
  testimonialsSection,
  faqsSection,
  blogSection,
}: {
  video: React.ReactNode;
  expertiseSection: React.ReactNode;
  aboutSection: React.ReactNode;
  testimonialsSection: React.ReactNode;
  faqsSection: React.ReactNode;
  blogSection: React.ReactNode;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
  const headerContainerRef = useRef<HTMLDivElement | null>(null);
  const expertiseRef = useRef<HTMLDivElement | null>(null);
  const aboutRef = useRef<HTMLDivElement | null>(null);
  const contactRef = useRef<HTMLDivElement | null>(null);

  useScrollRestoration();

  return (
    <>
      <SLHomeEntryOverlay video={video} />

      <SLLayoutGeneral enableEntryAnimation={true}>
        <header>
          <SLHomeHeader
            containerRef={headerContainerRef}
            isMobile={isMobile}
            video={video}
          />
        </header>

        <SLNavigation
          contentContainerMaxWidth="xl"
          headerContainerRef={headerContainerRef}
          expertiseRef={expertiseRef}
          aboutRef={aboutRef}
          contactRef={contactRef}
        />

        <main>
          <Box
            sx={{
              position: "relative",
              zIndex: 1,
              mt: 6,
            }}
          >
            <Stack sx={{ zIndex: 3 }}>
              <section ref={expertiseRef}>{expertiseSection}</section>

              <section ref={aboutRef}>{aboutSection}</section>

              <section>{testimonialsSection}</section>

              <section>{faqsSection}</section>

              <section>{blogSection}</section>

              <Divider />

              <section>
                <SLHomeContact
                  contactRef={contactRef}
                  backgroundColor={theme.palette.background.default}
                />
              </section>
            </Stack>
          </Box>
        </main>

        <footer>
          <SLFooter />
        </footer>
      </SLLayoutGeneral>
    </>
  );
}
